module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/hero-login-b00ac471ec171c730fa3a5898a2a5656.svg";